import {
  NumberType,
  PhoneType,
} from "@redotech/redo-support-common/support/phone/phone-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { object, string } from "zod";
export const setupPhoneNumber = {
  name: "setupPhoneNumber" as const,
  input: object({
    phoneNumber: string(),
    phoneType: createEnum(PhoneType),
    numberType: createEnum(NumberType),
    termsOfUseUrl: string().optional(),
    privacyPolicyUrl: string().optional(),
  }),
  output: object({}),
};

export type SetupPhoneNumberInput = z.infer<typeof setupPhoneNumber.input>;
export type SetupPhoneNumberOutput = z.infer<typeof setupPhoneNumber.output>;
